module.exports = __webpack_public_path__ + "img/20200515_163732.365d4f3f.jpg";